import { dropStatusDocumento, dropStatusGarantia } from 'utils/drops';

const getGarantiasFilterFields = (drops = {}) => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusDocumento,
    multiple: true,
  },
  {
    name: 'situacao',
    column: 'status',
    label: 'Situação',
    type: 'select',
    options: dropStatusGarantia,
    multiple: true,
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
    type: 'number',
    initial: true,
  },
  {
    name: 'dtemissao.i',
    column: 'documento',
    label: 'Data de Emissão Inicial',
    type: 'date',
  },
  {
    name: 'dtemissao.f',
    column: 'documento',
    label: 'Data de Emissão Final',
    type: 'date',
  },
  {
    name: 'user',
    column: 'documento',
    label: 'Emitente',
    type: 'select',
    options: drops?.Users,
    multiple: true,
  },
  {
    name: 'filial',
    column: 'documento',
    label: 'Filial',
    type: 'select',
    options: drops?.Filial,
    multiple: true,
  },
  {
    name: 'vendedor',
    column: 'documento',
    label: 'Vendedor',
    type: 'select',
    options: drops?.EntidadeTipo?.filter((f) => f?.tipo === 'VENDEDOR'),
    multiple: true,
  },
  {
    name: 'cliente',
    column: 'documento',
    label: 'Cliente',
    type: 'virtual-select',
    options: drops?.Entidade,
    multiple: true,
  },
  {
    name: 'fabricante',
    column: 'documento',
    label: 'Código do Fabricante',
  },
  {
    name: 'produto',
    label: 'Produto',
  },
  {
    name: 'quantidade',
    column: 'produto',
    label: 'Quantidade',
    type: 'currency',
  },
  {
    name: 'preco',
    column: 'produto',
    label: 'Preço',
    type: 'currency',
  },
  {
    name: 'unidade_medida',
    column: 'produto',
    label: 'Unidade de Medida',
    type: 'select',
    options: drops?.UnidadeMedida,
    multiple: true,
  },
  {
    name: 'marca',
    column: 'produto',
    label: 'Marca',
    type: 'select',
    options: drops?.Marca,
    multiple: true,
  },
];

export default getGarantiasFilterFields;
